(function () {
    'use strict';
    angular.module('emarket.store.static', [ 'ui.router' ]).config(['$stateProvider', function ($stateProvider) {
        $stateProvider.state('store.static', {
            views: {
                store: {
                    template: '<ui-view name="static" flex layout="column"></ui-view>'
                }
            }
        }).state('store.static.about', {
            url: '/sobre-nosotros',
            views: {
                static: {
                    templateUrl: 'store/statics/store-static.tpl.html',
                    controller: 'StoreStaticController as model'
                }
            }
        }).state('store.static.policies', {
            url: '/politica-de-compras',
            views: {
                static: {
                    templateUrl: 'store/statics/store-static.tpl.html',
                    controller: 'StoreStaticController as model'
                }
            }
        }).state('store.static.contact', {
            url: '/contacto',
            views: {
                static: {
                    templateUrl: 'store/statics/store-static-contact.tpl.html',
                    controller: 'StoreStaticController as model'
                }
            }
        });
    }]);
}());

(function () {
    'use strict';
    angular.module('emarket.store.static', [ 'ui.router' ]).config(['$stateProvider', function ($stateProvider) {
        $stateProvider.state('store.static', {
            views: {
                store: {
                    template: '<ui-view name="static" flex layout="column"></ui-view>'
                }
            }
        }).state('store.static.about', {
            url: '/sobre-nosotros',
            views: {
                static: {
                    templateUrl: 'store/statics/store-static.tpl.html',
                    controller: 'StoreStaticController as model'
                }
            }
        }).state('store.static.policies', {
            url: '/politica-de-compras',
            views: {
                static: {
                    templateUrl: 'store/statics/store-static.tpl.html',
                    controller: 'StoreStaticController as model'
                }
            }
        }).state('store.static.contact', {
            url: '/contacto',
            views: {
                static: {
                    templateUrl: 'store/statics/store-static-contact.tpl.html',
                    controller: 'StoreStaticController as model'
                }
            }
        });
    }]);
}());
